const extractionConfiguration = {
  ExtractionConfiguration: "Configuración de Extracción",
  extraction_configuration: "Configuración de Extracción",
  keep_first_page_title: "Conservar solo la primera página",
  keep_first_page_description:
    "Si el texto del documento contiene alguna de las etiquetas siguientes, solo se procesa la página 1 del PDF. Se ejecuta antes de la clasificación.",
  remove_watermark_title: "Eliminar marca de agua",
  remove_watermark_description:
    'Si el texto del documento contiene alguna de las etiquetas siguientes, se elimina la marca de agua. Se ejecuta después de "Conservar solo la primera página", por lo que solo ve la página 1 cuando se aplicó.',
  tags_placeholder: "Escribe una etiqueta y pulsa Enter",
  tags_hint:
    "La coincidencia ignora mayúsculas y minúsculas. Máximo {{max}} etiquetas, {{length}} caracteres cada una.",
  add: "Añadir",
  enable_toggle_to_edit_tags: "Activa el interruptor para añadir o editar etiquetas",
  save: "Guardar",
  configuration_saved_successfully: "Configuración guardada correctamente",
  organization_not_found: "Organización no encontrada.",
  extraction_config_organization_id_mismatch:
    "La organización de la URL y la de la solicitud no coinciden.",
  extraction_config_watermark_tags_required:
    "Añade al menos una etiqueta de marca de agua para activar la eliminación.",
  extraction_config_watermark_tags_max_exceeded:
    "No se permiten más de {{max}} etiquetas de marca de agua.",
  extraction_config_watermark_tag_too_long:
    "Una etiqueta de marca de agua no puede tener más de {{max}} caracteres.",
  extraction_config_keep_first_page_tags_required:
    "Añade al menos una etiqueta para activar la opción de conservar solo la primera página.",
  extraction_config_keep_first_page_tags_max_exceeded:
    "No se permiten más de {{max}} etiquetas.",
  extraction_config_keep_first_page_tag_too_long:
    "Una etiqueta no puede tener más de {{max}} caracteres.",
};

export default extractionConfiguration;
